import { render, staticRenderFns } from "./GapList.vue?vue&type=template&id=4101a494"
import script from "./GapList.vue?vue&type=script&lang=js"
export * from "./GapList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports